import { Service } from '@/tools'
export class SpuService<T extends TCommodity.Spu> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Spu}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //作废spu
  invalid = <K extends T['ApiInvalidSpu']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInvalidSpu', data)
  //激活spu
  activation = <K extends T['ApiActivationSpu']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiActivationSpu', data)
  //spu打标签
  spuPlayTag = <K extends T['ApiSpuPlayTag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSpuPlayTag', data)
  //查询spu下标签集合 -- 无用 暂时保留，spu打标签后会添加至对应sku上
  querySpuTags = <K extends T['ApiQuerySpuTags']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQuerySpuTags', data)
  //通过id 查询 spu部分数据
  selectPartCommoditySpuById = <K extends T['ApiSelectPartCommoditySpuById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectPartCommoditySpuById', data)
  //查询spu列表
  querySpuPageList = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v2/ApiPage', data)

  //spu去重
  selectEncryptionSpu = <K extends T['ApiSelectEncryptionSpu']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSelectEncryptionSpu', data)

  //通过条码查询列表
  pageBarCodeList = <K extends T['ApiPageBarCodeList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageBarCodeList', data)

  //通过id查询下一个spuId   /api/commodity/spu/v1/selectNextCommoditySpuById
  selectNextCommoditySpuById = <K extends T['ApiSelectNextCommoditySpuById']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectNextCommoditySpuById', data)
}
